import { capitalizeFirstCharacter } from "@/helpers/utils";
import { createSlice } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";

const initialState = {
  activeState: 0,
  validatedState: {},
  inProgressStep: 0,
  basicDetails: {},
  policyDetails: {},
  medicalDetails: {},
  tataEmpVerified: false,
  proposalId: "",
  proposalProgress: {
    proposalNo: "",
    proposalId: "",
    bucket: "",
    stage: 0,
  },
  proposal: {},
  isReadOnly: false,
  proposalExpiry: false,
  proposalNo: "",
  isPEPCustomer: false,
  isPEPCustomerProposalRejected: false,
  pepMatchedStatus: "",
  refetchProposalFlag: false,
  additionalConsentInfo: {
    isAnyMemberAutoRejected: false,
    members: [],
  },
  proposalCreationCompleted: false,
  kycCompleted: false,
  premiumObj: {},
  isNstp: false,
  bancaDetails: {},
  professionalDiscountVerified: {},
  professionalDetailsDataPA: {},
};
export const proposalSlicePa = createSlice({
  name: "proposalPa",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    updateActiveStatePA: (state, action) => {
      state.activeState = action.payload;
    },
    updateActiveStateByOnePA: (state) => {
      state.activeState += 1;
    },
    updateActiveStateByMinusOnePA: (state) => {
      state.activeState -= 1;
    },
    setValidatedStatePA: (state, action) => {
      state.validatedState = action.payload;
    },
    updateValidatedStatePA: (state, action) => {
      state.validatedState = {
        ...state.validatedState,
        ...action.payload,
      };
    },
    updateInProgressStepPA: (state, action) => {
      state.inProgressStep = action.payload;
    },
    setBasicDetailsPA: (state, action) => {
      state.basicDetails = action.payload;
    },
    updateBasicDetailsPA: (state, action) => {
      state.basicDetails = action.payload;
    },
    setPolicyDetailsPA: (state, action) => {
      state.policyDetails = action.payload;
    },
    updatePolicyDetailsPA: (state, action) => {
      state.policyDetails = action.payload;
    },
    setMedicalDetailsPA: (state, action) => {
      state.medicalDetails = action.payload;
    },
    updateMedicalDetailsPA: (state, action) => {
      state.medicalDetails = action.payload;
    },
    setIsTataEmployeeVerifiedPA: (state, action) => {
      state.tataEmpVerified = action.payload;
    },
    setProposalProgressPA: (state, action) => {
      state.proposalProgress = action.payload;
    },
    setProposalIdPA: (state, action) => {
      state.proposalId = action.payload;
    },
    setIsReadOnlyPA: (state, action) => {
      state.isReadOnly = action.payload;
    },
    updateProposalExpiryPA: (state, action) => {
      state.proposalExpiry = action.payload;
    },
    setIsPEPCustomerPA: (state, action) => {
      state.isPEPCustomer = action.payload;
    },
    setIsPEPCustomerProposalRejectedPA: (state, action) => {
      state.isPEPCustomerProposalRejected = action.payload;
    },
    setPEPMatchedStatusPA: (state, action) => {
      state.pepMatchedStatus = action.payload;
    },
    setProposalNumberPA: (state, action) => {
      state.proposalNo = action.payload;
    },
    setRefetchProposalPA: (state, action) => {
      state.refetchProposalFlag = action.payload;
    },
    updateAdditionalConsentInfoPA: (state, action) => {
      state.additionalConsentInfo = action.payload;
    },
    setProposalPA: (state, action) => {
      state.proposal = action.payload;
    },
    setIsProposalCreationCompletedPA: (state, action) => {
      state.proposalCreationCompleted = action.payload;
    },
    setKycCompletedPA: (state, action) => {
      state.kycCompleted = action.payload;
    },
    setPaymentInfoPA: (state, action) => {
      state.paymentInfo = action.payload;
    },
    setPremiumObjPA: (state, action) => {
      state.premiumObj = action.payload;
    },
    clearProposalDataPA: (state, action = { payload: {} }) => {
      // Use the payload to set specific state while clearing the proposal data.
      // Pass payload as empty in case you need to clear the whole state
      return { ...initialState, ...action.payload };
    },
    setIsNstpPA: (state, action) => {
      state.isNstp = action.payload;
    },
    setBancaDetailsPA: (state, action) => {
      state.bancaDetails = action.payload;
    },
    updateProfessionalDiscountVerified: (state, action) => {
      state.professionalDiscountVerified = action.payload;
    },
    setProfessionalDetailsDataPA: (state, action) => {
      state.professionalDetailsDataPA = action.payload;
    },
  },
});
export const {
  updateActiveStatePA,
  updateActiveStateByOnePA,
  updateActiveStateByMinusOnePA,
  setValidatedStatePA,
  updateValidatedStatePA,
  updateInProgressStepPA,
  setBasicDetailsPA,
  updateBasicDetailsPA,
  setMedicalDetailsPA,
  updateMedicalDetailsPA,
  setPolicyDetailsPA,
  updatePolicyDetailsPA,
  setIsTataEmployeeVerifiedPA,
  setProposalProgressPA,
  setProposalIdPA,
  setIsReadOnlyPA,
  updateProposalExpiryPA,
  setIsPEPCustomerPA,
  setIsPEPCustomerProposalRejectedPA,
  setPEPMatchedStatusPA,
  setProposalNumberPA,
  setRefetchProposal,
  setRefetchProposalPA,
  setProposalPA,
  updateAdditionalConsentInfoPA,
  setIsProposalCreationCompletedPA,
  setKycCompletedPA,
  setPaymentInfoPA,
  clearProposalDataPA,
  setPremiumObjPA,
  setIsNstpPA,
  setBancaDetailsPA,
  updateProfessionalDiscountVerified,
  setProfessionalDetailsDataPA,
} = proposalSlicePa.actions;

export const getActiveStatePA = (state) => state.proposalPa?.activeState;
export const getValidatedStatePA = (state) => state.proposalPa?.validatedState;
export const getInProgressStatePA = (state) => state.proposalPa?.inProgressStep;
export const getBasicDetailsPA = (state) => state.proposalPa?.basicDetails;
export const getPolicyDetailsPA = (state) => state.proposalPa?.policyDetails;
export const getMedicalDetailsPA = (state) => state.proposalPa?.medicalDetails;
export const getIsTataEmployeeVerifiedPA = (state) =>
  state.proposalPa?.tataEmpVerified;
export const getProposalProgressPA = (state) =>
  state.proposalPa?.proposalProgress;
export const getProposalBucketPA = (state) => {
  if (!isEmpty(state.proposalPa?.proposalProgress?.bucket)) {
    return state.proposalPa?.proposalProgress?.bucket; // TO Check the logic here
  } else {
    return state.proposalPa?.proposal?.proposalStatus?.currentStatus || "";
  }
};
export const getProposalFullNamePA = (state) => {
  const { basicDetails, proposal } = state.proposalPa;
  if (!isEmpty(proposal)) {
    return [
      capitalizeFirstCharacter(proposal?.proposer?.firstName),
      capitalizeFirstCharacter(proposal?.proposer?.middleName),
      capitalizeFirstCharacter(proposal?.proposer?.lastName),
    ].join(" ");
  } else {
    //TODO: Set the propos
    if (!isEmpty(basicDetails.proposer)) {
      return capitalizeFirstCharacter(basicDetails.proposerfullName);
    } else {
      const proposerMember =
        !isEmpty(basicDetails) &&
        basicDetails.members.find((mem) => mem.relationship === "Self");
      if (!isEmpty(proposerMember)) {
        return capitalizeFirstCharacter(proposerMember.fullName);
      }
      return "";
    }
  }
};
export const getProposalIdPA = (state) => state.proposalPa?.proposalId;
export const getIsReadOnlyPA = (state) => state.proposalPa?.isReadOnly;
export const getProposalExpiryPA = (state) => state.proposalPa?.proposalExpiry;
export const getProposalDataPA = (state) => state.proposalPa?.proposal;
export const getProposalNoPA = (state) => state.proposalPa?.proposalNo;

export const getIsPEPCustomerPA = (state) => {
  return state.proposalPa.isPEPCustomer;
};
export const getIsPEPCustomerProposalRejectedPA = (state) => {
  return state.proposalPa.isPEPCustomerProposalRejected;
};
export const getPEPMatchedStatusPA = (state) => {
  return state.proposalPa.pepMatchedStatus;
};
export const getRefetchProposalFlagPA = (state) =>
  state.proposalPa.refetchProposalFlag;
export const getAddtionalConsentInfoPA = (state) =>
  state.proposalPa.additionalConsentInfo;
export const getProposalPA = (state) => state.proposalPa?.proposal;
export const getProposalCreationCompletedPA = (state) =>
  state.proposalPa?.proposalCreationCompleted;
export const getKycCompletedPA = (state) => state.proposalPa?.kycCompleted;
export const getProposalStatusPA = (state) =>
  state.proposalPa.proposal?.proposalStatus || {};
export const getPaymentInfoPA = (state) => state.proposalPa?.paymentInfo;
export const getPremiumObjPA = (state) => state.proposalPa?.premiumObj;
export const getIsNstpPA = (state) => {
  return state.proposalPa?.isNstp;
};
export const getBancaDetailsPA = (state) => state.proposalPa?.bancaDetails;
export const getProposalConsentDataPA = (state) =>
  state.proposalPa.proposal?.consent || {};
export const getProfessionalDiscountVerified = (state) =>
  state.proposalPa?.professionalDiscountVerified;
export const getProfessionalDetailsDataPA = (state) =>
  state.proposalPa?.professionalDetailsDataPA;

export default proposalSlicePa.reducer;
